import { render, staticRenderFns } from "./InviteUserToJoinTeam.vue?vue&type=template&id=0f62aeaf&scoped=true"
import script from "./InviteUserToJoinTeam.vue?vue&type=script&lang=js"
export * from "./InviteUserToJoinTeam.vue?vue&type=script&lang=js"
import style0 from "./InviteUserToJoinTeam.vue?vue&type=style&index=0&id=0f62aeaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f62aeaf",
  null
  
)

/* custom blocks */
import block0 from "./InviteUserToJoinTeam.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports